<form [formGroup]="form">
  <div class="container-form m-t-8">
    <p class="h5 title-form">{{ 'approvalspage.formAccountDetails.companyBillingAddress' | cxTranslate }}</p>

    @if (form.get('billingAddressIsEqualWorkAddress')?.value) {
      <div class="form-group m-0">
        <div class="form-check m-0">
          <label class="m-0">
            <input type="checkbox" formControlName="billingAddressIsEqualWorkAddress" />
            <span class="form-check-label">{{ 'approvalspage.formAccountDetails.billingAddressIsEqualWorkAddress' | cxTranslate }}</span>
            <cx-form-errors [control]="form.get('billingAddressIsEqualWorkAddress')"></cx-form-errors>
          </label>
        </div>
      </div>
    } @else {
      <form-address [form]="form" [countries$]="countries$"></form-address>
    }
  </div>

  <div class="container-form m-t-16">
    <p class="h5 title-form">{{ 'approvalspage.formAccountDetails.productCategory' | cxTranslate }}</p>

    @if (form.disabled) {
      <div class="form-group">
        <label>
          <span class="label-content">{{ 'approvalspage.formAccountDetails.productCategoriesOfInterest' | cxTranslate }}</span>
          <input class="form-control" type="text" name="productCategory" maxlength="255" placeholder="" formControlName="productCategory" />
          <cx-form-errors [control]="form.get('productCategory')"></cx-form-errors>
        </label>
      </div>
    } @else {
      <ng-container *ngIf="productCategories$ | async as productCategories">
        <div class="form-group">
          <label>
            <span class="label-content">{{ 'approvalspage.formAccountDetails.productCategoriesOfInterest' | cxTranslate }}</span>

            <select class="form-control" formControlName="productCategory">
              <option value="productCategory" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
              <option *ngFor="let item of productCategories" [attr.aria-label]="item.label" value="{{ item.code }}">
                {{ item.label }}
              </option>
            </select>

            <cx-form-errors [control]="form.get('productCategory')"></cx-form-errors>
          </label>
        </div>
      </ng-container>
    }
  </div>
</form>
